(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('GiftController', GiftController);

	GiftController.$inject = ['$window', '$log', 'API', 'ENV'];

	function GiftController($window, $log, API, ENV) {
		// userPouch needs to be injected for ENV to come through.

		/* jshint validthis: true */
		var self = this;

		self.gift = {
			// gift amount
			amount: null,
			// stripe.js token obj
			token: null,
			metadata: {
				// purchasers email
				email: null
			}
		};

		// error message
		self.message = '';

		// methods
		self.buy = buy;
		self.pay = pay;
		self.print = print;

		self.stripeKey = ENV.STRIPE_KEY;

		/** begin methods */

		function pay(token){
			// @todo validate interger before stripe shows up
			// bug: enter 10.50 in amount, enter stripe info then you hit buy and it gives you HTML5 error
			// we want the error earlier.

			self.gift.token = token;

			// @todo set inputs to disabled (unless that changes the model)
			// or hide them and show elsewhere.
			// you can enter 1 in amount and auth 1 in stripe.js
			// then edit afterwards to be 100, I believe this will have a stripe error but we
			// should avoid.
		}

		function buy(){
			API.gift(self.gift).then(function(response){
				$log.debug('API register response', response);
				// display success giftcode
				self.gift.giftcode = response.data.giftcode;
			}).catch(function(response){
				self.message = response.data.error;
			});
		}

		function print(){
			return $window.print();
		}

	}

})();
